import * as React from 'react'
import Star from '../icons/ui/Star'

interface IRating {
  rating: number
}

class Rating extends React.Component<IRating, any, any> {
  public render() {
    return <div>{this.rating()}</div>
  }

  private rating = () => {
    const stars = []
    for (let i = 0; i < this.props.rating; i++) {
      stars.push(<Star key={`rating-star-${i}`} className='svg-green mr1' height={16} width={16} />)
    }
    return stars
  }
}

export default Rating



// WEBPACK FOOTER //
// ./src/components/ui/Ratings.tsx